import React from 'react';
import './header.css';
import logo from '../../img/logo.svg';
import backgroundImg from '../../img/taking_notes.svg';

const Header = ({ setSearchTodo }) => {
  return (
    <header>
      <div className='header'>
        <div className='header__top'>
          <h1>Приложение для составления списков дел</h1>
          <a className='header__logo' href='https://senlainc.com/'>
            <img src={logo} alt='SENLA' />
          </a>
          <form className='header__form' action='#'>
            <div className='header__form-content'>
              <input
                type='search'
                className='header__search-task search-task'
                placeholder='Search task for to do'
                onChange={(e) => {
                  setSearchTodo(e.target.value);
                }}
              />
            </div>
          </form>
        </div>
        <img className='header__background-img' src={backgroundImg} alt='' />
      </div>
    </header>
  );
};

export default Header;
